import { render, staticRenderFns } from "./WikiDataSpreadsheetSync.vue?vue&type=template&id=053a1006"
import script from "./WikiDataSpreadsheetSync.vue?vue&type=script&lang=ts"
export * from "./WikiDataSpreadsheetSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports